<template>
  <div>
      <div class="col col-md-6 col-lg-7 hidden-sm-down">
          <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                  <div class="carousel-item active">
                      <img class="d-block w-100" src="/img/slider/1.png" alt="First slide">
                  </div>
                  <div class="carousel-item">
                      <img class="d-block w-100" src="/img/slider/2.png" alt="Second slide">
                  </div>
                  <div class="carousel-item">
                      <img class="d-block w-100" src="/img/slider/3.png" alt="Third slide">
                  </div>
              </div>
              <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Назад</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Вперед</span>
              </a>
          </div>
          <h2 class="fs-xxl fw-500 mt-4 text-white">
              Система мониторинга сайтов и серверов

              <small class="h3 fw-300 mt-3 mb-5 text-white opacity-60">
                  В текущий момент сервис работает в <b>тестовом</b> режиме и поддерживает:<br>
                  <br>
                  <ul>
                    <li>HEAD запросы с проверкой кода ответа</li>
                    <li>GET запросы с проверкой наличия ключевого слова на сайте</li>
                    <li>PING для мониторинга доступности сервера</li>
                    <li>API для управления задачами и контактами</li>
                    <li>уведомления о событиях на почтовый ящик</li>
                  </ul>
              </small>
          </h2>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto">
          <h1 class="text-white fw-300 mb-3 d-sm-block d-md-none">
              Авторизация
          </h1>
          <div class="card p-4 rounded-plus bg-faded">
              <form data-form="login" @submit.prevent="processLogin">
                  <div class="form-group">
                      <label class="form-label">Почтовый ящик</label>
                      <input type="email" data-input="mail" class="form-control form-control-lg" v-bind:class="{ 'is-invalid': 'mail' in errors}" v-on:focus="$delete(errors, 'mail')" v-model="mail" v-focus>
                      <div class="invalid-feedback" v-if="'mail' in errors">{{ errors['mail'] }}</div>
                  </div>
                  <div class="form-group">
                      <label class="form-label" for="password">Пароль</label>
                      <input type="password" data-input="password" class="form-control form-control-lg" v-bind:class="{ 'is-invalid': 'password' in errors}" v-on:focus="$delete(errors, 'password')" v-model="password">
                      <div class="invalid-feedback" v-if="'password' in errors">{{ errors['password'] }}</div>
                  </div>
                  <div class="row no-gutters">
                      <div class="col-lg-12 pr-lg-1 my-2">
                          <button type="submit" data-button="login" class="btn btn-success btn-block btn-lg">Войти</button>
                      </div>
                      <router-link tag="button" class="btn btn-info btn-block btn-lg mt-2" :to="{name: 'account/restore'}">
                        Восстановить пароль
                      </router-link>
                  </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Авторизация',
    },
    data() {
      return {
        // Поля
        mail: '',
        password: '',
        // Ошибки
        errors: {}
      }
    },
    methods: {
      processLogin () 
      {
        // Отправка запроса к API
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/users/login', {mail: this.mail, password: this.password}).then(response => 
        {
          if(response.data.status == 'success')
          {
            // Сохранение идентификатора сессии
            localStorage.token = response.data.token;

            // Перенаправление на главную
            this.$router.push({name: 'index'});
          }
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      }
    }
  }
</script>